import React from 'react';

import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

export const EmptyOptionButton = (props: React.ComponentProps<typeof Box>) => {
    return <Box height={62} flex={1} backgroundColor={ds.colorToken.background.neutral.subtler} {...props} />;
};
